import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import VisitInformation from '../../../components/VisitInformation';

const BookAppointmentConfirmation = ({
  provider,
  patient,
  tenancy,
  appointment,
  referringProvider,
  classes,
}) => {
  const { fullTitle: providerName } = provider;
  const { name: patientName } = patient;
  const { startTimestamp: appointmentStart } = appointment;

  return (
    <Grid container spacing={8} className={classes.root}>
      <Grid item xs={12} sm={4} className={classes.visitInfo}>
        <VisitInformation
          provider={provider}
          tenancy={tenancy}
          appointmentTime={appointmentStart}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography component="h2" className={classes.headerText}>
          You’re all set!
        </Typography>

        {referringProvider ? (
          provider.premium ? (
            <Typography component="p" className={classes.subtext}>
              You've referred {patientName} to {providerName}! We've sent both
              parties an email with all of the details.
            </Typography>
          ) : (
              <Grid>
                <Typography component="p" className={classes.subtext}>
                  You've referred {patientName} to {providerName}. The patient has
                  received all the information.
              </Typography>
                <Typography component="p" className={classes.subtext}>
                  Please advise the patient to reach out to {providerName} to
                  schedule an appointment, or contact concierge@qwell.com if they
                  need assistance.
              </Typography>
                <Typography component="p" className={classes.subtext}>
                  A courtesy email has been sent to {providerName} advising{' '}
                  {providerName} of this referral, but no specific patient
                  information has been sent.
              </Typography>
              </Grid>
            )
        ) : (
            <Typography component="p" className={classes.subtext}>
              You've booked an appointment for {patientName} with {providerName}{' '}
              and we've sent both parties an email with all of the details.
          </Typography>
          )}

        <Typography component="p" className={classes.subtext}>
          Thanks for booking with Qwell!
        </Typography>
      </Grid>
    </Grid>
  );
};

BookAppointmentConfirmation.propTypes = {
  patient: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
  appointment: PropTypes.object.isRequired,
  tenancy: PropTypes.object.isRequired,
};

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    width: '100%',
    height: '100%',
  },
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1024px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withStyles(styles)(BookAppointmentConfirmation);
